// extracted by mini-css-extract-plugin
export default {"fields":"qMwUVP","time":"Buw3mv","mobile":"jaxJQ7"};